import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.primary};

  .tablePedidos:not(td) {
    background-color: #e6f7ff !important;
  }
`;
